/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramConnectionsUserControllerMarkIncomingAsReadMutationResponse,
  TelegramConnectionsUserControllerMarkIncomingAsRead401,
} from '../types/TelegramConnectionsUserControllerMarkIncomingAsRead.ts';

function getTelegramConnectionsUserMarkIncomingAsReadUrl() {
  const res = { method: 'PATCH', url: `/api/user/telegram/connections/incoming/read` as const };
  return res;
}

/**
 * @summary Mark all incoming connections as read
 * {@link /api/user/telegram/connections/incoming/read}
 */
export async function telegramConnectionsUserMarkIncomingAsRead(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramConnectionsUserControllerMarkIncomingAsReadMutationResponse,
    ResponseErrorConfig<TelegramConnectionsUserControllerMarkIncomingAsRead401>,
    unknown
  >({ method: 'PATCH', url: getTelegramConnectionsUserMarkIncomingAsReadUrl().url.toString(), ...requestConfig });
  return res.data;
}
